import api from './api'

export const signTerms = terms => api.post('/sign_term/', terms)

export const signTermPartnership = terms => api.post('/use_terms/accept/', terms)
